/**
 * 대부거래 금전소비대차계약서 전용 스크립트 (so_c2034.html)
 * 관리자로부터 전송된 데이터를 계약서 필드에 바인딩
 */

// 더미 데이터 (실제로는 서버/관리자로부터 받아올 데이터)
const contractData = {
  // 대부업자 정보
  creditorRegNo: '2024-서울-0001',
  creditorBizRegNo: '123-45-67890',
  creditorAddress: '서울특별시 강남구 테헤란로 123, 빌리언빌딩 10층',
  creditorContact: '1833-8996',
  
  // 채무자 정보
  debtorName: '홍길동',
  debtorSsn: '800101-1******',
  debtorAddress: '서울특별시 강남구 역삼동 123-45',
  debtorPhone: '010-1234-5678',
  debtorEmail: 'hong@example.com',
  
  // 대출 기본조건
  loanProductName: '참!좋은 주식담보대출',
  loanApplicationNo: 'L2024120501',
  loanAmountContract: '5,000만',
  loanExecutionDate: '2024년 12월 05일',
  loanStartDate: '2024년 12월 05일',
  loanMaturityDateContract: '2025년 06월 05일',
  loanPurpose: '주식 매입자금',
  
  // 이자 관련
  agreedInterestRate: '연 6.5%',
  defaultInterestRate: '연 23.0%',
  
  // 상환방법
  repaymentType1: '☑',  // 만기일시상환
  repaymentType2: '',
  repaymentType3: '',
  repaymentType4: '',
  repaymentTypeEtc: '',
  repaymentCycle: '☑ 매월',
  repaymentDate: '매월 5일',
  
  // 납부방법
  paymentMethod1: '☑',  // 자동이체
  paymentMethod2: '',
  paymentMethod3: '',
  paymentMethodEtc: '',
  
  // 중도상환수수료
  midRepaymentFeeRate: '0%',
  midRepaymentFeeBasis: '조기상환 원금 × 0% 이내, 및 관련 법령이 정하는 범위 내',
  
  // 담보 정보
  pledgeSecuritiesCompany: 'DB증권',
  pledgeAccountNo: '123-45-678901',
  pledgeAccountHolder: '홍길동',
  
  // 계약체결 정보
  contractDate: '2024년 12월 05일',
  signatureDebtorName: '홍길동 (전자서명)',
  signatureMethod: '공동인증서'
};

/**
 * 데이터 바인딩 함수
 */
function bindContractData() {
  Object.keys(contractData).forEach(key => {
    const element = document.getElementById(key);
    if (element) {
      // 체크박스 마크인 경우 (repaymentType, paymentMethod)
      if (key.startsWith('repaymentType') && key !== 'repaymentTypeEtc' ||
          key.startsWith('paymentMethod') && key !== 'paymentMethodEtc') {
        // 체크 표시가 있으면 ✓ 표시
        if (contractData[key] === '☑' || contractData[key] === '✓') {
          element.textContent = '✓';
        } else {
          element.textContent = '';
        }
      } else {
        // 일반 데이터 바인딩
        element.textContent = contractData[key];
        
        // 데이터가 채워진 필드는 강조 표시
        if (contractData[key] && contractData[key] !== '') {
          element.classList.add('data-filled');
        }
      }
    }
  });
}

/**
 * 계약서 확인 버튼 핸들러
 * @param {Function} onConfirmCallback - 확인 완료 시 실행할 콜백 함수 (Vue ref 업데이트용)
 */
function handleContractConfirm(onConfirmCallback) {
  const confirmBtn = document.getElementById('contractConfirmButton');
  if (!confirmBtn) return;
  
  confirmBtn.addEventListener('click', function() {
    // 계약서 내용을 확인했음을 표시
    this.textContent = '확인 완료';
    this.disabled = true;
    this.style.backgroundColor = '#4caf50';
    
    // 사용자에게 알림
    alert('계약 내용을 확인하셨습니다.\n이제 전자서명을 진행해 주세요.');
    
    // Vue ref 업데이트 콜백 실행 (전달된 경우)
    if (typeof onConfirmCallback === 'function') {
      onConfirmCallback();
    }
    
    // 공동인증서 섹션으로 스크롤 이동 및 버튼 활성화
    const certButton = document.getElementById('certButton');
    if (certButton) {
      certButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // 스크롤 후 버튼 활성화 및 포커스
      setTimeout(() => {
        certButton.disabled = false;
        certButton.focus();
      }, 500);
    }
  });
}

/**
 * 페이지 로드 시 초기화
 */
document.addEventListener('DOMContentLoaded', function() {
  // so_c2034 페이지는 항상 새로 시작 (세션 초기화)
  sessionStorage.removeItem('certCompleted');
  
  // 전자서명 상태 초기화
  const certStatus = document.getElementById('certStatus');
  if (certStatus) {
    certStatus.style.display = 'none';
    certStatus.textContent = '';
  }
  
  // 공동인증서 버튼 초기 비활성화 확인
  const certButton = document.getElementById('certButton');
  if (certButton) {
    certButton.disabled = true;
    certButton.classList.remove('completed');
  }
  
  // 더미 데이터 바인딩 (개발/테스트용)
  // 실제 운영 시에는 서버로부터 데이터를 받아와서 바인딩
  bindContractData();
  
  // 계약서 확인 버튼 이벤트 설정
  handleContractConfirm();
});

// ES 모듈 export
export { bindContractData, handleContractConfirm };

// 전역 스코프에 노출 (필요한 경우)
if (typeof window !== 'undefined') {
  window.bindContractData = bindContractData;
  window.handleContractConfirm = handleContractConfirm;
}
